// src/constants/brandService.js
import axios from 'axios';
import { applyBrandNameCorrections } from '../utils/brandNameCorrections';

const API_BASE_URL = process.env.REACT_APP_API_BASE || 'https://trendmix-backend-service-864903803368.asia-northeast3.run.app';

export const getBrandRankings = async (
  page = 1,
  perPage = 20,
  sortBy = 'search_trend',
  sortOrder = 'desc',
  category = null,
  lang = 'ko'
) => {
  try {
    console.log('Fetching brand rankings with params:', { page, perPage, sortBy, sortOrder, category });
    
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
      sort_by: sortBy,
      sort_order: sortOrder,
      lang: lang
    });

    if (category) {
      params.append('category', category);
    }

    const response = await axios.get(`${API_BASE_URL}/api/v1/brands/rankings?${params}`);
    console.log('Brand rankings response:', response.data);
    return applyBrandNameCorrections(response.data, lang);
  } catch (error) {
    console.error('Error fetching brand rankings:', error.response || error);
    throw error;
  }
};

export const getBrandDetails = async (brandId, lang = 'ko') => {
  try {
    console.log('Fetching brand details for:', brandId, 'with language:', lang);
    
    const params = new URLSearchParams({
      lang: lang
    })
    
    const response = await axios.get(`${API_BASE_URL}/api/v1/brands/details/${brandId}?${params}`);
    console.log('Brand details response:', response.data);
    return applyBrandNameCorrections(response.data, lang);
  } catch (error) {
    console.error('Error fetching brand details:', error.response || error);
    throw error;
  }
}; 